import { PageHeader } from '@organisms';
import { coupons } from '@service/api';
import { Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';
import { CouponDigital } from 'src/models';

import { LayoutConfirmationFooter } from '../../../molecules/LayoutConfirmationFooter/LayoutConfirmationFooter.molecule';
import { DigitalCouponForm } from '../components/CouponForm/DigitalCouponForm.component';
import { useProductDigitalCoupon } from '../hooks/useProductDigitalCoupon';

export function EditCouponDigitalPage() {
  const { id } = useParams<{ id?: string }>();
  const navigate = useNavigate();
  const couponHookData = useProductDigitalCoupon();

  const [coupon, setCoupon] = useState<
    CouponDigital.IDigitalCoupon | undefined
  >(undefined);

  useEffect(() => {
    couponHookData.setIsLoading(true);
    coupons
      .getDigitalCouponById(Number(id))
      .then(couponData => setCoupon(couponData))
      .catch((error: Error) => {
        OpenNotification(true, 'Erro', error.message, undefined, () => {
          navigate(-1);
        });
      })
      .finally(() => couponHookData.setIsLoading(false));
  }, []);

  return (
    <Spin spinning={couponHookData.isLoading}>
      <LayoutConfirmationFooter
        onCancel={couponHookData.handleCancel}
        onSave={couponHookData.dispatchSubmit}
        cancelLabelButton='Descartar'
        ableToSave
      >
        <PageHeader
          backToPath={() => {
            navigate(-1);
          }}
          title={`Formulário para edição do Cupom ${
            coupon ? coupon.code : '...'
          }`}
          subTitle={'Desconto de um valor específico. Exemplo: R$10,00 OFF.'}
        />
        <DigitalCouponForm
          coupon={coupon}
          isEditing={true}
          couponHookData={couponHookData}
        />
      </LayoutConfirmationFooter>
    </Spin>
  );
}
